import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import P1 from "literacy/assets/fonts/p1";
import P2 from "literacy/assets/fonts/p2";
import P3 from "literacy/assets/fonts/p3";

const useStyles = makeStyles({
  root: {
    width: 380,
    margin: 10,
  },
  media: {
    height: 170,
  },
});

export default function TrainCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root} variant="outlined" style={{ backgroundColor: 'transparent', border: 'solid', borderColor: 'rgb(240,240,240)' }}>
      <CardActionArea href={props.page} style={{ textDecoration: "none" }}>
        <CardContent>
          <Typography gutterBottom className="text-primary">
            <P2>{props.title}</P2>
          </Typography>
          <Typography color="textSecondary">
            <P3>{props.description}</P3>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
